
/**
 * 向服务器推送程序错误日志等
 */

// 微信企业号--系统消息告警
import request from './raw-request';

const MAX_EVENT_COUNT = 5;
const oldConsole = Object.assign({}, console);

let events = [];
let getContext = function() {};
let getCurrentPage = function() {};

// 让Error在JSON.stringify时带上message, stack
const stringifyReplacer = (key, value) => {
  if (value instanceof Error) {
    const {message, stack} = value;
    value = Object.assign({ message, stack}, value);
  }
  return value;
};

const send = events => {
  const payload = {
    events,
    context: getContext()
  };

  return request({
    url: 'https://cdn.rsscc.cn/trainact3/act3/log/appletHelpLogs.action',
    data: {
      errfrom: 'web-gaotie-vue',
      text: JSON.stringify(payload, stringifyReplacer)
    }
  }).catch(() => {});
};

const push = level => (...args) => {
  try {
    if (typeof oldConsole[level] === 'function') {
      oldConsole[level](...args);
    } else {
      oldConsole.info && oldConsole.info(...args);
    }

    events.push({
      t: new Date().toString(),
      page: getCurrentPage(),
      data: args.length === 1 ? args[0] : args
    });

    if (events.length > MAX_EVENT_COUNT) {
      events = events.slice(-MAX_EVENT_COUNT);
    }

    if (level === 'error') {
      send(events.slice().reverse());
      events = [];
    }

  } catch (error) {}
};

const logger = {
  debug: push('debug'),
  log: push('log'),
  info: push('info'),
  warn: push('warn'),
  error: push('error'),
  hook: function(console, opts = {}) {
    Object.assign(console, logger);
    if (opts.getContext) getContext = opts.getContext;
    if (opts.getCurrentPage) getCurrentPage = opts.getCurrentPage;
  }
};

export default logger;



// WEBPACK FOOTER //
// ./src/utils/logger.js